import { render, staticRenderFns } from "./compLoader.vue?vue&type=template&id=6284696b&"
import script from "./compLoader.vue?vue&type=script&lang=js&"
export * from "./compLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports